export const GET_CIRRUSOFT = 'Get Cirrusoft DE';
export const BLOG_READ_MORE = 'mehr lesen';

// Join section
export const JOIN_TITLE = 'Dein Laden. Ihr Setup.';
export const JOIN_SUB_TITLE =
  'Unser hervorragendes technisches Team hilft Ihnen bei einem reibungslosen und nahtlosen Übergang. Fangen Sie einfach an!';
export const JOIN_BTN = 'Beginnen Sie mit Cirrusoft';
